import {faGraduationCap, faSuitcase} from "@fortawesome/free-solid-svg-icons";
import {TableDataTypes} from "../components/table/TableList";
import axios from "axios";
const domainPath = '/api';
const fixedbase = 'http://130.88.233.193/dgate.php?address=127.0.0.1&port=5678&mode=start&AE=CONQUESTSRV1&parameter=';
function getErrorHandled(err) {
    console.log(err);
    // if(err.status === 500){}
    return err.response.data.message;
}

export default class tableDataModules {


    static lastModulesTable = {};
    static lastSelectedModuleID = null;
    static getModuleOverview(filter='',sort=0){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+"/module?filter="+filter+"&sort="+sort,{
                withCredentials: false} )
                .then(async response => {

                    let dataStructure = [];
                    for (let i = 0; i < response.data.length; i++) {
                        let module = response.data[i];
                        dataStructure.push([module.id,module.name,module.caseCount , module.studentCount,module.createdOn , "1"])
                        this.lastModulesTable[module.id] = response.data[i];
                    }
                    resolve(dataStructure);
                    console.log(dataStructure);
                })
                .catch(err => {
                    reject({error: true,message: getErrorHandled(err)});
                });
        })
    }

    static getCasesFromModule(moduleID){

            return new Promise((resolve, reject) => {
                axios.get(domainPath+"/case/bymodule/"+moduleID,{
                    withCredentials: false} )
                    .then(response => {
                        resolve(response.data);
                    })
                    .catch(err => {
                        reject({error: true,message: getErrorHandled(err)});
                    });
            })

    }
    static getPendingGenQue(){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+"/case/generation/queue",{
                withCredentials: false} )
                .then(response => {
                    if(response.data !== null){
                        resolve(response.data);
                    }
                })
                .catch(err => {
                    reject({error: true,message: getErrorHandled(err)});
                });
        })
    }
    static getCaseData(caseID){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+"/case/"+caseID,{
                withCredentials: false} )
                .then(response => {
                    if(response.data !== null){
                        console.log(response.data)
                        resolve(response.data);
                    }
                })
                .catch(err => {
                    reject({error: true,message: getErrorHandled(err)});
                });
        })
    }
    static getSubmissions(caseID){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+"/student/case/"+caseID,{
                withCredentials: false} )
                .then(response => {
                    if(response.data !== null){
                        resolve(response.data);
                    }
                })
                .catch(err => {
                    reject({error: true,message: getErrorHandled(err)});
                });
        })
    }

    static getGoldenStandards(caseName){
        return new Promise((resolve, reject) => {
            axios.get(fixedbase+'dicomquery&level=IMAGE&query={QueryRetrieveLevel=%22IMAGE%22,PatientID=%22'+caseName+'%22,SOPInstanceUID=%22%22,InstanceNumber=%22%22,ImageID=%22%22,Modality=%22%22,SeriesDescription=%22Gold%20standard%22,StudyInstanceUID=%22%22}',{
                withCredentials: false} )
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject({error: true,message: getErrorHandled(err)});
                });
        })
    }
    static saveRule(structure){
        return new Promise((resolve, reject) => {
            axios.put(domainPath+'/rules', structure).then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true,message: getErrorHandled(err)});
            });
        });
    }
    static createRule(structure,caseID){
        return new Promise((resolve, reject) => {
            axios.post(domainPath+'/rules/'+caseID, structure).then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true,message: getErrorHandled(err)});
            });
        });
    }

    static editCase(casenew,caseID){
        return new Promise((resolve, reject) => {
            axios.post(domainPath+'/case/'+caseID+"/additionalData", casenew).then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true,message: getErrorHandled(err)});
            });
        });
    }

    static deleteRule(ruleID,confirm=false){
        return new Promise((resolve, reject) => {
            axios.delete(domainPath+'/rules/delete/'+ruleID+"?confirm="+(confirm ? 'true' : 'false')).then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true,message: getErrorHandled(err)});
            });
        });
    }

    static getStructsByCase(caseId){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+'/case/'+caseId+"/structs",{withCredentials: false} )
                .then(response => {
                    resolve(response);
                })
                .catch(err => {
                    reject({error: true,message: getErrorHandled(err)});
                });
        })
    }

    static getRulesByCase(caseId){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+'/rules/'+caseId,{
                withCredentials: false} )
                .then(async response => {
                    resolve(response);
                })
                .catch(err => {
                    reject({error: true,message: getErrorHandled(err)});
                });
        })
    }

    static getRuleOrganWeightsByCase(caseId){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+'/rules/'+caseId+"/organweights",{
                withCredentials: false} )
                .then(async response => {
                    resolve(response);
                })
                .catch(err => {
                    reject({error: true,message: getErrorHandled(err)});
                });
        })
    }

    static editOrganWeightByCase(caseID, organWeights){
        return new Promise((resolve, reject) => {
            axios.post(domainPath+'/rules/'+caseID+"/organweights", organWeights).then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true,message: getErrorHandled(err)});
            });
        });
    }

    static regenerateCase(caseID,distance){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+'/case/'+caseID+"/regenerate/"+distance).then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true,message: getErrorHandled(err)});
            });
        });
    }

    static reprocessCase(caseID){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+'/case/'+caseID+"/reprocess").then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true,message: getErrorHandled(err)});
            });
        });
    }

    static deleteCase(caseID){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+'/case/'+caseID+"/delete").then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true,message: getErrorHandled(err)});
            });
        });
    }

    static createSession(caseID){
        return new Promise((resolve, reject) => {
            axios.put(domainPath+'/case/'+caseID+"/create/session").then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true,message: getErrorHandled(err)});
            });
        });
    }

    static getStudents(){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+'/student').then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true,message: getErrorHandled(err)});
            });
        });
    }
    
    static getStudent(studentId){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+'/student/'+encodeURIComponent(studentId)).then(res => {
                // Check if this was a handled 403 error
                if (res._handled403) {
                    reject({error: true, message: "Access denied"});
                } else {
                    resolve(res);
                }
            }).catch(err => {
                reject({error: true,message: getErrorHandled(err)});
            });
        });
    }

    static getCasesFromStudent(number){
        return new Promise((resolve, reject) => {
            axios.get(domainPath+'/student/'+encodeURIComponent(number)+"/cases").then(res => {
                resolve(res.data);
            }).catch(err => {
                reject({error: true,message: getErrorHandled(err)});
            });
        });
    }
    
    static updateStudent(studentNumber, data) {
        return new Promise((resolve, reject) => {
            axios.put(domainPath+'/student/'+encodeURIComponent(studentNumber), data).then(res => {
                // Check if this was a handled 403 error
                if (res._handled403) {
                    reject({error: true, message: "Access denied"});
                } else {
                    resolve(res);
                }
            }).catch(err => {
                reject({error: true, message: getErrorHandled(err)});
            });
        });
    }
    
    static deleteStudent(studentNumber) {
        return new Promise((resolve, reject) => {
            axios.delete(domainPath+'/student/'+encodeURIComponent(studentNumber)).then(res => {
                // Check if this was a handled 403 error
                if (res._handled403) {
                    reject({error: true, message: "Access denied"});
                } else {
                    resolve(res);
                }
            }).catch(err => {
                reject({error: true, message: getErrorHandled(err)});
            });
        });
    }
    
    static updateModule(moduleId, data) {
        return new Promise((resolve, reject) => {
            axios.put(domainPath+'/module/'+moduleId, data).then(res => {
                // Check if this was a handled 403 error
                if (res._handled403) {
                    reject({error: true, message: "Access denied"});
                } else {
                    resolve(res);
                }
            }).catch(err => {
                reject({error: true, message: getErrorHandled(err)});
            });
        });
    }
    
    static deleteModule(moduleId) {
        return new Promise((resolve, reject) => {
            axios.delete(domainPath+'/module/'+moduleId).then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true, message: getErrorHandled(err)});
            });
        });
    }
    
    static resetPassword(studentNumber) {
        return new Promise((resolve, reject) => {
            axios.post(domainPath+'/student/'+encodeURIComponent(studentNumber)+'/resetPassword').then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true, message: getErrorHandled(err)});
            });
        });
    }

    static updateUserRoles(studentNumber, roles) {
        return new Promise((resolve, reject) => {
            axios.put(domainPath+'/student/'+encodeURIComponent(studentNumber)+'/roles', roles).then(res => {
                resolve(res);
            }).catch(err => {
                reject({error: true, message: getErrorHandled(err)});
            });
        });
    }
    //
    // static getRuleTemplate(caseName){
    //     return new Promise((resolve, reject) => {
    //         axios.get(domainPath+'inholland/data/'+caseName+'//GS/Template.json?_='+Date.now(),{
    //             withCredentials: false} )
    //             .then(async response => {
    //                 let StructArray = [];
    //                 for (let i = 0; i < response.data.length; i++) {
    //                     if(response.data[i].Structure !== undefined){
    //                         StructArray.push(response.data[i].Structure);
    //                     }
    //                 }
    //                 const res = await axios.get(fixedbase + "downloadtable&filename=rules4" + caseName + ".json&_=" + Date.now(), {withCredentials: false});
    //                 const RuleArray = {};
    //                 for (let i = 0; i < StructArray.length; i++) {
    //                     if(res.data[StructArray[i]] === undefined){
    //                         res.data[StructArray[i]] = {
    //                             "dist2OtherRules": [],
    //                             "lengthRules": [],
    //                             "struct2GSrules": [],
    //                             "structName": StructArray[i],
    //                             "volumeRules": [],
    //                             "weight": 10
    //                         }
    //                     }
    //                 }
    //                 resolve(res.data);
    //             })
    //             .catch(err => {
    //                 reject({error: true,message: getErrorHandled(err)});
    //             });
    //     })
    // }
    //
    // static saveRules(caseName,structure){
    //     return new Promise((resolve, reject) => {
    //         axios.put(fixedbase + "uploadtable&backup=false&filename=rules4" + caseName + ".json", structure).then(res => {
    //             resolve(res);
    //         }).catch(err => {
    //             reject({error: true,message: getErrorHandled(err)});
    //         });
    //     });
    // }

    static functionMillisToDate(milis){
        const dateObj = new Date(milis);
        return ('0' + dateObj.getDate()).slice(-2) + '/'
        + ('0' + (dateObj.getMonth()+1)).slice(-2) + '/'
        + dateObj.getFullYear();
    }
    static getColumnData(){
        return [
            {name: "moduleID", type: TableDataTypes.hidden},
            {name: "Module ID", type: TableDataTypes.title, size: 3, sortable: true},
            {name: "Cases", type: TableDataTypes.iconCount,props: {icon: faSuitcase}, size: 2, sortable: true},
            {name: "Students", type: TableDataTypes.iconCount,props: {icon: faGraduationCap}, size: 2, sortable: true},
            {name: "Created on", type: TableDataTypes.date, size: 2, sortable: true},
            {name: "Sessions", type: TableDataTypes.dropDown,props: {items: ["1","2"]}, size: 2, sortable: false},
            {name: ".", type: TableDataTypes.button, props: {variant: "outline-primary", icon: "pencil", onClick: "editModule"}, size: 1, sortable: false}
        ];
    }
    static getColumnsGoldenStandard(){
        return [
            {name: "Name", type: TableDataTypes.title, size: 8}
        ];
    }


    // static getStudentCount(moduleName){
    //     return new Promise((resolve, reject) => {
    //
    //         //Caching script:
    //         if ((moduleName in this.cache_student_info)){
    //             if(Date.now() - this.cache_student_info[moduleName].stamp < 1000*60*3){
    //                 resolve(this.cache_student_info[moduleName].object);
    //                 console.log("[tableDataModules/getStudentCount]: read "+moduleName+" from cache");
    //                 return;
    //             }
    //         }
    //
    //         axios.get(fixedbase+"dicomquery&level=IMAGE&query={QueryRetrieveLevel=%22IMAGE%22,PatientID=%22"+moduleName+"_*%22,SOPInstanceUID=%22%22,ImageID=%22%22,Modality=%22RTSTRUCT%22,SeriesDescription=%22Observers%22,StudyInstanceUID=%22%22}",{
    //             withCredentials: false} )
    //             .then(response => {
    //                 if(response.data === 0){
    //                     console.log("Empty module: "+ moduleName);
    //                     resolve([]);
    //                 }else{
    //                     let cleanArray = [];
    //                     for (let i = 0; i < response.data.length; i++) {
    //                         cleanArray[response.data[i].ImageID] = response.data[i];
    //                     }
    //                     this.cache_student_info[moduleName] = {};
    //                     this.cache_student_info[moduleName]['stamp'] = Date.now();
    //                     this.cache_student_info[moduleName]['object'] = cleanArray;
    //                     resolve(cleanArray);
    //                 }
    //             })
    //             .catch(err => {
    //                 reject({error: true,message: getErrorHandled(err)});
    //             });
    //     })
    // }
    // static getModulesInfo(){
    //     return new Promise((resolve, reject) => {
    //         axios.get(fixedbase+"dicomquery&level=PATIENT&query={QueryRetrieveLevel=%22PATIENT%22,PatientID=%22*%22}",{
    //             withCredentials: false} )
    //             .then(async response => {
    //
    //                 let dataStructure = {};
    //                 for (let i = 0; i < response.data.length; i++) {
    //                     let strArray = response.data[i].PatientID.split('_');
    //                     if (strArray.length < 2) {
    //                         continue;
    //                     }
    //                         if (!(strArray[0] in dataStructure)) {
    //                             let studentfile = await this.getStudentCount(strArray[0]);
    //                             dataStructure[strArray[0]] = {
    //                                 studentfile: studentfile,
    //                                 caseFiles: {},
    //                                 created: Date.now(),
    //                             }
    //                         }
    //                     let caseData = await this.getCaseData(response.data[i].PatientID);
    //                     dataStructure[strArray[0]].caseFiles[response.data[i].PatientID] = (caseData);
    //                     if(caseData.created < dataStructure[strArray[0]].created){
    //                         dataStructure[strArray[0]].created = caseData.created;
    //                     }
    //                 }
    //
    //                 this.lastModulesTable = dataStructure;
    //                 let uniqueArray = [];
    //                 for (const moduleName in dataStructure) {
    //                     const dataStructObj = dataStructure[moduleName];
    //                     const dateStr = this.functionMillisToDate(dataStructObj.created);
    //                     uniqueArray.push([moduleName,Object.keys(dataStructObj.caseFiles).length , Object.keys(dataStructObj.studentfile).length,dateStr , "1"]);
    //                 }
    //
    //                 resolve((uniqueArray));
    //                 console.log(dataStructure);
    //             })
    //             .catch(err => {
    //                 reject({error: true,message: getErrorHandled(err)});
    //             });
    //     })
    // }


}